import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedserviceService } from 'src/app/services/sharedservice.service';
import { MustMatch } from 'src/app/services/must-match';
declare var $:any;
@Component({
  selector: 'app-deal',
  templateUrl: './deal.component.html',
  styleUrls: ['./deal.component.scss']
})
export class DealComponent implements OnInit {
  dropCity:boolean=true;
  searchForm:FormGroup;
  travellers:FormGroup;
  total:any;
  flight:any;
  type:any = 'oneway';
  selecttype:any='Select By Airline';
  disableInput: boolean;
  return_date:string;
  constructor(private activatedRoute: ActivatedRoute, private fb: FormBuilder, public httpClient: SharedserviceService, public router: Router) {
    //this.user.jwt="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjo1LCJ1c2VyX2VtYWlsIjoidGVzdDJAZ21haWwuY29tIiwidHlwZSI6ImN1c3RvbWVycyJ9.krOysYurlj4bu4swegrU92AzmuIAmE0cRhvAyJ-YqNw";
  }

  ngOnInit() {
    this.disableInput = true;
    //$('#returndate').prop("disabled", true);
    //$('#returndate').prop("disabled", false);
    this.searchForm = this.fb.group({
      type:[''],
      from_to:[''],
      departure_date:[''],
      return_date:[''],
      travellers:[''],
    });
    
    this.travellers = this.fb.group({
      adult:[''],
      child:[''],
      infant:[''],
    });

  }

  Change_Status(val){
    if(val=='oneway'){
      this.disableInput = true;
      this.return_date = '';
    }else{
      this.disableInput = null;
    }
  }

  open_popup(){
    $('#totalpassengers').modal('show');
  }
  
  traveller(){
    var adult = this.travellers.value.adult;
    var child = this.travellers.value.child;
    var infant = this.travellers.value.infant;
    
    if(adult !='' && child !='' && infant !=''){
      if(parseInt(adult) >= parseInt(infant)){
        this.total = parseInt(adult) + parseInt(child) + parseInt(infant);
        $('#totalpassengers').modal('hide');
        this.searchForm.patchValue({travellers:this.total});
      }else{
        alert('Please select infant less than adult');
      }
      
    }else{
      alert('All Field is required');
    }
      
    
  }

  searchData(){
    alert(JSON.stringify(this.searchForm.value));
    //var type = this.searchForm.value.type;
    const self=this;
    //this.httpClient.auth_token = this.user.jwt;
    self.httpClient.loadingShow = true;
    //self.regForm.patchValue({token:this.token});
     
    this.httpClient.post('searchFlights',this.searchForm.value).subscribe((res)=> {
    self.httpClient.loadingShow = false;
      if(res.success) { 
        localStorage.setItem("user_emailAgency", JSON.stringify(res.data));
        localStorage.setItem("type",'register');
        self.flight = res.data;
        
//console.log('flight Data', self.flight);
        $('#success').show();
          setTimeout(function(){
            $('#success').hide();
          }, 2000);
        }else{
          $('#error').show();
          setTimeout(function(){
            $('#error').hide();
          }, 4000);
      }
    });
    
  }

    
  

}
